import React from 'react';

export const ArrowUp = () => (
  <div className="arrow arrow-up">
    <i className="fas fa-arrow-right fa-2x" />
  </div>
);
